export default "__VITE_ASSET__Dgyo321N__"